import { FC } from 'react'

import { Button as btn, TextInput as inp } from '../uiKit'
import { StickerFile } from '../../pages/AddAnimatedStickers'

const TextInput = inp as any
const Button = btn as any

interface StickerAddingFormProps {
  stickerFiles: StickerFile[]
  isDataSending: boolean
}

export const StickerAddingForm: FC<StickerAddingFormProps> = ({
  stickerFiles,
  isDataSending,
}) => {
  return (
    <>
      <div className="adding-stickers-form__fieldset">
        <TextInput
          bordered
          className="adding-stickers-form__input"
          required
          name="packName"
          onChange={() => {}}
          suffix={<div className="adding-stickers-form__suffix">Name pack</div>}
        />
        <TextInput
          bordered
          className="adding-stickers-form__input"
          onChange={() => {}}
          type="number"
          min={0}
          placeholder="0"
          name="packPrice"
          prefix={
            <div className="adding-stickers-form__suffix adding-stickers-form__prefix">
              MFC
            </div>
          }
          suffix={<div className="adding-stickers-form__suffix">Price</div>}
        />
      </div>
      <div className="adding-stickers-form__fieldset">
        <div className="adding-stickers-form__button">
          <Button
            loading={isDataSending}
            type="submit"
            disabled={!stickerFiles.length}
          >
            Send
          </Button>
        </div>
      </div>{' '}
    </>
  )
}
